<template>
	<div v-if="supplierCode" class="bordered bg-white mb-4" :class="cardWidth">
		<div class="logo-container px-2 m-2 d-flex align-items-center">
			<img src="/images/ostock-logo-gram.png">
		</div>
		<div class="my-2">
			<div class="supplier-code" v-if="supplierCode">{{ supplierCode }}</div>
			<div v-if="supplierOrigin" class="supplier-origin">
				<span v-if="showLabel" class="text-bold">Lokasi : </span>{{ supplierOrigin }}
			</div>
			<div v-if="fullWidth" class="mb-2 total-products">
				<span class="text-bold">Total Produk :</span> {{ totalProducts }}
			</div>
			<router-link v-else :to="`/supplier/${supplierCode}`">
				<button type="button" class="btn btn-primary my-2" :class="btnSm">
					Lihat Produk Supplier
				</button>
			</router-link>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		supplierCode: {
			type: String,
			default: '',
		},
		supplierOrigin: {
			type: String,
			default: '',
		},
		fullWidth: {
			type: Boolean,
			default: false,
		},
		showLabel: {
			type: Boolean,
			default: false,
		},
		totalProducts: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			isScreenSmall: window.innerWidth <= 768,
		};
	},
	methods: {
		updateScreenSize() {
			// Update the `isScreenSmall` property based on the window width
			this.isScreenSmall = window.innerWidth <= 768;
		},
	},
	computed: {
		cardWidth() {
			return {
				'pr-4 mx-4 mt-4': !this.fullWidth,
				'd-inline-flex': !this.fullWidth && !this.isScreenSmall,
				'd-flex': this.fullWidth || this.isScreenSmall,
			};
		},
		btnSm() {
			return {
				'btn-sm': this.isScreenSmall,
			};
		},
	},
	mounted() {
		// Add a window resize event listener to update the `isScreenSmall` data property
		window.addEventListener('resize', this.updateScreenSize);
	},
	beforeDestroy() {
		// Remove the event listener when the component is destroyed
		window.removeEventListener('resize', this.updateScreenSize);
	},
};
</script>

<style scoped>
.bordered {
	border: 1px solid rgba(0, 0, 0, .15);
	border-radius: 5px;
}

.logo-container {
	max-width: 100px;
}

.supplier-code {
	font-size: 24px;
	font-weight: 600;
}

.supplier-origin, .total-products {
	font-size: 16px;
}

@media only screen and (max-width: 768px) {
	.logo-container {
		max-width: 75px;
	}

	.supplier-code {
		font-size: 20px;
	}

	.supplier-origin, .total-products {
		font-size: 12px;
	}
}
</style>
